const dayjs = require('dayjs');
require('dayjs/locale/fr');

dayjs.locale('fr');

/**
 * Conversion of the date into a human readable format
 * @param date // date to be converted
 * @returns {string} // date converted
 */
function convertDateToReadableDate(date) {
  return dayjs(date).format('ddd D MMM');
}

/**
 * Conversion of dates into a human-readable format
 * @param start // start date to be converted
 * @param end // end date to be converted
 * @returns {string} // Return dates in a readable format
 */
function convertDateStartDateEndToLisibleDate(start, end) {
  if (start === end) {
    return dayjs(start).format('ddd D MMM');
  } else {
    const startConvert = dayjs(start);
    const endConvert = dayjs(end);

    if (startConvert.get('month') === endConvert.get('month')) {
      return `Du ${startConvert.format('ddd D')} au ${endConvert.format(
        'ddd D MMM',
      )}`;
    }
    return `Du ${startConvert.format('ddd D MMM')} au ${endConvert.format(
      'ddd D MMM',
    )}`;
  }
}

/**
 * Verification that the mission is in progress or not
 * @param start // Start date of the mission
 * @param end // End date of the mission
 * @returns {boolean} // Returns true if in progress otherwise false
 */
function currentMission(start, end) {
  const startDate = dayjs(start);
  const endDate = dayjs(end);
  const now = dayjs();

  return (
    now >= startDate && now <= endDate.set('date', endDate.get('date') + 1)
  );
}

function taskToDo(end) {
  const endDate = dayjs(end);
  const now = dayjs();
  return endDate.set('date', endDate.get('date') + 1) > now;
}

/**
 * @param input - The input string in the format "HH:mm"
 */
function stringToFloat(input) {
  if (input === 0) return 0;
  const time = input.split(':');
  return parseInt(time[0]) + parseInt(time[1]) / 60;
}

/**
 * @param input - The input float to convert to a string in the format "HH:mm"
 */
function floatToString(input, separator = ':') {
  if (!input) return `00${separator}00`;

  const totalMinutes = Math.round(input * 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  const paddedHours = hours.toString().padStart(2, '0');
  const paddedMinutes = minutes.toString().padStart(2, '0');

  return `${paddedHours}${separator}${paddedMinutes}`;
}

function generateFiveMinuteIntervals() {
  const intervals = [];
  for (let i = 0; i < 60; i += 5) {
    intervals.push(i.toString().padStart(2, '0'));
  }

  return intervals;
}

/**
 * Round minutes to the nearest 5 minutes
 * @param minutes - The minutes value
 * @returns {number} - Minutes rounded to nearest 5 minutes
 */
function roundToFiveMinutes(minutes) {
  const remainder = minutes % 5;

  if (remainder < 2.5) {
    return minutes - remainder;
  } else {
    return minutes + (5 - remainder);
  }
}

export {
  convertDateToReadableDate,
  convertDateStartDateEndToLisibleDate,
  currentMission,
  taskToDo,
  stringToFloat,
  floatToString,
  generateFiveMinuteIntervals,
  roundToFiveMinutes,
};
